import React from "react";

import Tooltip from "shared/components/Tooltip";
import Icon from "shared/components/Icon";

import { Checkbox, CheckboxProps } from "../Checkbox";
import { SwitchTitle } from "../SwitchTitle";

import { CheckboxRow, Description, RequiredCountBadge, StyledActionLink } from "./styled";

type SwitchWithCheckboxListProps = CheckboxProps & {
  onChange: (id: string, checked: boolean, item?: any) => void;
  onChangeTitle: () => void;
  onManageList: () => void;
  value?: boolean;
  title: string;
  description?: string;
  items: {
    label: string;
    description?: string;
    tooltipText?: string;
    requiredCount?: number;
    id: string;
    checked?: boolean;
    disabled?: boolean;
  }[];
  disabled?: boolean;
};

export const SwitchWithCheckboxList: React.FC<SwitchWithCheckboxListProps> = ({
  title,
  description,
  items,
  value,
  onChange,
  onChangeTitle,
  onManageList,
  disabled,
  ...props
}) => (
  <>
    <SwitchTitle
      title={title}
      onChange={onChangeTitle}
      description={description}
      value={value}
      data-testid="switch"
      hasItems={items.length > 0}
      disabled={disabled}
    />
    {value && (
      <>
        {items.map((item, index) => (
          <CheckboxRow key={item.id} isLastItem={items.length === index + 1}>
            <Checkbox
              id={`${item.id}`}
              label={item.label}
              checked={item.checked}
              onChange={() => onChange(item.id, !item.checked, item)}
              data-testid={item.id}
              disabled={disabled || item.disabled}
              {...props}
            />
            {item.requiredCount > 0 && (
              <RequiredCountBadge>x{item.requiredCount}</RequiredCountBadge>
            )}
            {item.tooltipText ? (
              <Tooltip title={item.tooltipText}>
                <span style={{ marginLeft: 6, display: "inline-flex", cursor: "pointer" }}>
                  <Icon.InfoIcon className="extra-info" />
                </span>
              </Tooltip>
            ) : item.description ? (
              <Description>({item.description})</Description>
            ) : null}
          </CheckboxRow>
        ))}
        <StyledActionLink
          onClick={() => onManageList()}
          data-testid="manage-list"
          disabled={disabled}
        >
          Manage List
        </StyledActionLink>
      </>
    )}
  </>
);
